export default function () {
    return {
      peopleList:[],
    }
  }